import { z } from 'zod';
import { CONTACT_ROLES } from '../enums.js';
import { optionalText, patchSchemaOf } from './common.js';
export const contactInputSchema = z.object({
    companyId: z.string().uuid(),
    fullName: z.string().trim().min(2, 'Contact name is required').max(140),
    fullNameAr: optionalText,
    title: optionalText,
    role: z.enum(CONTACT_ROLES).default('other'),
    email: z.union([z.string().trim().toLowerCase().email(), z.literal('')]).optional(),
    phone: optionalText,
    isPrimary: z.boolean().default(false),
    notes: optionalText,
});
export const contactUpdateSchema = patchSchemaOf(contactInputSchema).omit({ companyId: true });
//# sourceMappingURL=contact.js.map